module.exports = __webpack_public_path__ + "assets/img/thumb-Nexon-5-Landing-Page.a7a29881.webp";